import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const TemplatesManagementRoutes = [
    {
        "url": "/brand/:brand_id/social-referral",
        "name": "appLayout.harriSH.social-referral-templates",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/templates-management/templates-management.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/social-referral/${hmapPathParamRegex}`,
        "name": "appLayout.harriSH.access-portal.settings.social-referral-templates",
        "params": {
            ...hmapPathParamConfig
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/templates-management/templates-management.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/manage",
        "name": "appLayout.harriSH.offerTemplates.manage",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/templates-management/templates-management.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/manage/${hmapPathParamRegex}`,
        "name": "appLayout.harriSH.access-portal.settings.offerTemplates.manage",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/templates-management/templates-management.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/settings",
        "name": "settings",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/templates-management/templates-management.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=templates-management.routes.js.map